import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Alerta } from './alerta.types';

@Injectable({
    providedIn: 'root',
})
export class AlertaService {
    public alerta$: BehaviorSubject<Alerta | null> = new BehaviorSubject<Alerta | null>(null);

    public aoIncluirAlerta: (() => void) | null = null;

    private alertas: Alerta[] = [];

    private alertaTimeout: number = 6200;

    public sucesso(mensagem: string): void {
        this.processaMensagemAlerta(new Alerta(mensagem, 'SUCCESS'));
    }

    public info(mensagem: string): void {
        this.processaMensagemAlerta(new Alerta(mensagem, 'INFO'));
    }

    public erro(mensagem: string): void {
        this.processaMensagemAlerta(new Alerta(mensagem, 'ERROR'));
    }

    private processaMensagemAlerta(alerta: Alerta): void {
        this.alertas.push(alerta);
        if (this.alertas.length === 1) this.lidarComInclusaoAlerta(alerta);
    }

    private lidarComFluxoDeMensagem = (): void => {
        this.alertas = this.alertas.filter((snack) => !snack.equals(this.alerta$.value));
        this.alerta$.next(null);
        if (this.alertas.length > 0) this.lidarComInclusaoAlerta(this.alertas.shift());
    };

    private lidarComInclusaoAlerta(alerta: Alerta | undefined): void {
        if (alerta) {
            this.alerta$.next(alerta);
            if (this.aoIncluirAlerta) this.aoIncluirAlerta();
            setTimeout(this.lidarComFluxoDeMensagem, this.alertaTimeout);
        }
    }
}
